import type { QuoteWorkspaceType } from 'state/workspaces/model';

import type { PendingQuoteDetailsData } from './pendingDetails.model';

export type PendingQuoteDetailsActions = PendingQuoteDetailsSaved;
export function pendingQuoteDetailsSaved(
  quoteId: string,
  workspace: QuoteWorkspaceType,
  data: PendingQuoteDetailsData,
) {
  return {
    type: 'PENDING_QUOTE_DETAILS_SAVED' as const,
    quoteId,
    workspace,
    data,
  };
}

export type PendingQuoteDetailsSaved = ReturnType<typeof pendingQuoteDetailsSaved>;
